import apiClient from '@/services/apiClient';

const B = '/processing-jo';
const d = (p) => p.then((r) => r.data);

export const joApi = {
  meta: () => d(apiClient.get(`${B}/meta`)),
  fgSearch: (q) => d(apiClient.get(`${B}/fg-search`, { params: { q } })),
  create: (body) => d(apiClient.post(`${B}/orders`, body)),
  list: (params = {}) => d(apiClient.get(`${B}/orders`, { params })).then((r) => r.orders || []),
  get: (joId) => d(apiClient.get(`${B}/orders/${joId}`)),
  articles: (joId) => d(apiClient.get(`${B}/orders/${joId}/articles`)),
  colourSplit: (body) => d(apiClient.post(`${B}/colour-split`, body)),
  stockExport: (joIds) => d(apiClient.post(`${B}/orders/stock-export`, { jo_ids: joIds })),
  createSlip: (joId, lines) => d(apiClient.post(`${B}/orders/${joId}/slips`, { lines })),
  setRoute: (joId, route) => d(apiClient.post(`${B}/orders/${joId}/route`, { route })),
  cancelBalance: (joId, reason) => d(apiClient.post(`${B}/orders/${joId}/cancel-balance`, { reason })),
  close: (joId, body) => d(apiClient.post(`${B}/orders/${joId}/close`, body)),
  slips: (params = {}) => d(apiClient.get(`${B}/slips`, { params })).then((r) => r.slips || []),
  slip: (slipId) => d(apiClient.get(`${B}/slips/${slipId}`)),
  pick: (slipId, code) => d(apiClient.post(`${B}/slips/${slipId}/pick`, { bundle_code: code })),
  unpick: (slipId, code) => d(apiClient.post(`${B}/slips/${slipId}/unpick`, { bundle_code: code })),
  cancelSlip: (slipId, reason) => d(apiClient.post(`${B}/slips/${slipId}/cancel`, { reason })),
  transfer: (slipId) => d(apiClient.post(`${B}/slips/${slipId}/transfer`)),
  alerts: () => d(apiClient.get(`${B}/alerts`)),
  pendingReport: (params = {}) => d(apiClient.get(`${B}/reports/pending`, { params })),
  jobberReport: (params = {}) => d(apiClient.get(`${B}/reports/jobbers`, { params })),
  stuck: (stages = []) => d(apiClient.get(`${B}/stuck`, { params: { stages: stages.join(',') } })),
  traceCode: (code) => d(apiClient.get(`${B}/trace-code`, { params: { code } })),
  traceReport: (params = {}) => d(apiClient.get(`${B}/reports/trace`, { params })),
  scorecard: (params = {}) => d(apiClient.get(`${B}/reports/scorecard`, { params })),
  returnChecks: (params = {}) => d(apiClient.get(`${B}/return-checks`, { params })),
  returnCheck: (id) => d(apiClient.get(`${B}/return-checks/${id}`)),
  decideCheck: (id, approve, remarks) => d(apiClient.post(`${B}/return-checks/${id}/${approve ? 'approve' : 'reject'}`, { remarks })),
};

export const joErr = (e, fallback = 'Something went wrong') => {
  const det = e?.response?.data?.detail;
  if (det && typeof det === 'object' && det.message) return det.message;
  return typeof det === 'string' ? det : fallback;
};

export const sendToText = (o) => (o.send_to_type === 'jobber' ? o.jobber_name : `Any ${o.category}`);
